export const ButtonVariant = {
  Primary: 'primary',
  Secondary: 'secondary',
  Ghost: 'ghost',
  Danger: 'danger',
  Link: 'link',
};

export const ButtonSize = {
  Sm: 'sm',
  Md: 'md',
  Lg: 'lg',
};

export const TextVariant = {
  Display: 'display',
  Title: 'title',
  Heading: 'heading',
  Subheading: 'subheading',
  Body: 'body',
  BodyLg: 'bodyLg',
  Caption: 'caption',
  Label: 'label',
  Mono: 'mono',
};

export const TextColor = {
  Primary: 'primary',
  Secondary: 'secondary',
  Tertiary: 'tertiary',
  Accent: 'accent',
  Danger: 'danger',
  Success: 'success',
  Inverse: 'inverse',
};

export const CardVariant = {
  Default: 'default',
  Interactive: 'interactive',
  Ghost: 'ghost',
};

export const DialogSize = {
  Sm: 'sm',
  Md: 'md',
  Lg: 'lg',
};
